<template>
  <nav class="navbar navbar-expand-md navbar-light navbar-laravel" style="background: #fff">
    <div class="container-fluid">
        <router-link :to="{ name: 'home' }" class="navbar-brand">
            <span class="font-size-xl text-dual-primary-dark logo-font">{{ appName }}</span>
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <router-link to="/" class="nav-link" active-class="active text-success" exact>{{ $t('app.index') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/stats" class="nav-link" active-class="active text-success">{{ $t('app.stats') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/rating" class="nav-link" active-class="active text-success">{{ $t('app.rating') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/payments" class="nav-link" active-class="active text-success">{{ $t('payments.index') }}</router-link>
            </li>
          </ul>

          <ul class="navbar-nav ml-auto">
              <li style="width: 250px;">
                <redemption-plan />
              </li>
              <li class="nav-item dropdown">
                  <a id="navbarDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{authUser ? authUser.firstname+' '+authUser.lastname : ''}} <span class="caret"></span>
                  </a>

                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <router-link :to="{ name: 'admin' }" class="dropdown-item" v-if="permissions.indexOf('access-adminpanel') != -1">
                      {{ $t('app.adminpanel') }}
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click.prevent="logout">
                        {{ $t('app.logout') }}
                    </a>
                  </div>
              </li>
          </ul>
        </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    RedemptionPlan: () => import('@/components/employee/stats/redemptionPlan'),
  },
  computed: {
    ...mapGetters([
      'authUser', 'permissions',
    ]),
  },
  methods: {
    ...mapActions([
      'LOGOUT',
    ]),
    logout() {
      this.LOGOUT()
        .then(() => {
          this.$router.push('/login');
        });
    },
  },
};
</script>
